import { cn } from "@workspace/web-ui/lib/utils"
import { DashboardDisplayCardProps } from "../../types/prop.types"

// Constants
const STYLES = {
  CARD: "flex flex-col gap-4 w-full p-4 rounded-[8px] bg-white border border-[#E6E6E6] justify-center items-center",
  ICON: "w-12 h-12",
  CONTENT: "flex flex-col gap-2 items-center justify-center",
  TITLE: "text-lg font-medium text-[#2D2F35]",
  DESCRIPTION: "text-sm text-muted-foreground break-words font-normal text-center",
} as const;

interface NoPreviewCardProps extends Omit<DashboardDisplayCardProps, 'onClick' | 'badge'> {
  /**
   * URL or path to the icon image
   */
  icon: string;
  /**
   * Card title text
   */
  title: string;
  /**
   * Descriptive text for the card
   */
  description: string;
  /**
   * Optional additional className for styling
   */
  className?: string;
  /**
   * Optional icon size for styling
   */
  iconSize?: string;
}

/**
 * NoPreviewCard component displays a simple card with an icon, title, and description
 * Used for displaying placeholder or empty state content
 */
const NoPreviewCard: React.FC<NoPreviewCardProps> = ({
  icon,
  title,
  iconSize,
  description,
  className,
}) => {
  return (
    <div 
      className={cn(STYLES.CARD, className)}
      role="article"
    >
      <img 
        src={icon} 
        alt={`${title} icon`}
        className={cn(STYLES.ICON, iconSize)}
        loading="lazy"
      />
      <div className={STYLES.CONTENT}>
        <h3 className={STYLES.TITLE}>
          {title}
        </h3>
        <p className={STYLES.DESCRIPTION}>
          {description}
        </p>
      </div>
    </div>
  );
};

export default NoPreviewCard